// The "Other work" tiles, shown on the home page and on /other-work.
// Animated tiles use short looping videos (they used to be GIFs); `image` is their poster frame.
const clip = (name) => ({
  webm: require(`@/assets/videos/${name}.webm`),
  mp4: require(`@/assets/videos/${name}.mp4`)
});

const otherWork = [
  { label: 'Photography', route: 'Photography', image: require('@/assets/images/thph.jpg') },
  { label: '3D', route: '3D', image: require('@/assets/videos/th3d-poster.jpg'), video: clip('th3d') },
  { label: '3D Printing', route: 'ThreeDPrinting', image: require('@/assets/videos/cursed_finger-poster.jpg'), video: clip('cursed_finger') },
  { label: 'Development', route: 'Development', image: require('@/assets/videos/thdev-poster.jpg'), video: clip('thdev') },
  { label: 'Videography', route: 'Video', image: require('@/assets/videos/thvid-poster.jpg'), video: clip('thvid') },
  { label: 'Graphic Design', route: 'GraphicDesign', image: require('@/assets/images/thgd.png') }
];

export default otherWork;
